const queue = [];
let sync = null;

const sa = function (category, action, label, value, software, uid) {
    software = software || 'LANDING';
    uid = uid || null

    function getUTM() {
        var url = document.location.href;
        var idx = url.indexOf('?');
        var query = idx > 0 ? url.substr(idx + 1) : null;
        var params = null;
        if (query) {
            params = {};
            query.split('&')
                .filter(function (p) {return p.startsWith('utm_')})
                .forEach(function (p) {
                    var matches = p.match(/utm_(.*)=(.*)/);
                    params[matches[1]] = decodeURIComponent(matches[2]);
                });
        }
        return params;
    }
    function serialize(obj) {
        if (!obj) {
            return '';
        } else if (typeof obj == 'string') {
            return encodeURIComponent(obj);
        } else if (typeof obj == 'object') {
            var s = '';
            for (var k in obj) {
                if (obj.hasOwnProperty(k) && obj[k] != undefined) {
                    if (s) {
                        s += '&';
                    }
                    s += k + '=' + encodeURIComponent(obj[k]);
                }
            }
            return s;
        } else {
            throw 'Unsupported object type';
        }
    }
    function merge(o1, o2) {
        if (!o1) {
            return o2;
        }
        if (!o2) {
            return o1;
        }
        if (Object.assign) {
            return Object.assign(o1, o2);
        }
        Object.getOwnPropertyNames(o2).forEach(n => o1[n]=o2[n]);
        return o1;
    }
    function sendEvent(e) {
        var utm = {};
        if (e.category == 'Pageview') {
            utm = getUTM();
        }

        return new Promise((resolve, reject) => {
            try {
                const xhr = new XMLHttpRequest();
                xhr.withCredentials = true;
                xhr.open("POST", `${$MAIN_HOST}/analytics/v1/events`, true);
                xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

                xhr.onload = resolve;
                xhr.onerror = reject;

                xhr.send(serialize(merge(e, utm)));
            } catch (e) {
                reject(e);
            }
        })
    }
    function send() {
        if (sync) {
            return sync;
        }
        const e = queue.shift();
        if (!e) {
            return;
        }

        return sync = sendEvent(e)
            .finally(() => sync = null)
            .then(() => send(), () => queue.unshift(e))
            .catch(() => queue.unshift(e));
    }

    queue.push({category: category, action: action, label: label, value: value, software: software, uid: uid});

    return send();
};

window.sa = sa;
module.exports = sa;